import { accessoryDrawerMutations } from './accessoryDrawer'
import { dashboardsMutations } from './dashboards'
import { layoutsMutations } from './layouts'

import { MutationResolvers } from '../../../generated/graphql'

export const Mutation: MutationResolvers = {
    ...dashboardsMutations,
    ...layoutsMutations,
    ...accessoryDrawerMutations,
}
